export default __webpack_public_path__ + "static/media/support@2x.256eff51.svg";